<template>
  <div class="ape-button" v-if="userPermissions.indexOf(permission) != -1">
    <div v-if="forceStyle">
      <el-tooltip :effect="effect" :content="content?content:name" :placement="placement"  v-if="forceStyle=='icon'" >
        <el-button :type="type" :size="size" :icon="'iconfont '+icon" @click="clickButton()" v-bind="$attrs"></el-button>
      </el-tooltip>
      <el-button :type="type" :size="size" @click="clickButton()" v-if="forceStyle=='text'" v-bind="$attrs">{{name}}</el-button>
    </div>
    <div v-else>
      <el-tooltip :effect="effect" :content="content?content:name" :placement="placement"  v-if="buttonStyle=='icon'" >
        <el-button :type="type" :size="size" :icon="'iconfont '+icon" @click="clickButton()" v-bind="$attrs"></el-button>
      </el-tooltip>
      <el-button :type="type" :size="size" @click="clickButton()" v-if="buttonStyle=='text'" v-bind="$attrs">{{name}}</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  // 属性
  props:{
    // Tooltip 组件主题
    effect:{
      type: String,
      default: 'dark'
    },
    // Tooltip 组件提示内容
    content:{
      type: String,
      default: ''
    },
    // Tooltip 提示显示位置
    placement:{
      type: String,
      default: 'top-start'
    },
    // 按钮类型
    type:{
      type: String,
      default: ''
    },
    // 按钮大小
    size:{
      type: String,
      default: 'medium'
    },
    // 按钮icon
    icon:{
      type: String,
      default: 'el-icon-eleme'
    },
    // 按钮名称
    name:{
      type: String,
      default: '攸米按钮'
    },
    // 按钮标识
    permission:{
      type: String,
      default: ''
    },
    // 强制按钮类型
    forceStyle:{
      type: String,
      default: ''
    }
  },
  // 定义属性
  data() {
    return {
      
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['userPermissions','buttonStyle'])
  },
  // 方法集合
  methods: {
    clickButton() {
      this.$emit('click')
    }
  }
}
</script>

<style lang='stylus'>
  .ape-button
    display inline-block
</style>